import { createApp } from 'vue'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/styles/app-version-dialog.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router'
import { setScriptActivityRouteProvider } from '@/workspace/scriptActivity'
import { startScriptLoadActivity } from '@/workspace/scriptLoadActivity'
import { hasPermission } from '@/api/auth'
import { registerMediaCacheServiceWorker } from '@/utils/mediaCacheServiceWorker'

// 抑制 ResizeObserver 循环警告（Element Plus el-table 常见问题，不影响功能）
const debounceError = window.onerror
window.onerror = (message, ...args) => {
  if (typeof message === 'string' && message.includes('ResizeObserver loop')) return false
  return debounceError?.(message, ...args) ?? false
}

const app = createApp(App)
setScriptActivityRouteProvider(() => router.currentRoute.value)
startScriptLoadActivity(router)

// 注册 Element Plus
app.use(ElementPlus)

// 注册路由
app.use(router)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册权限指令
app.directive('permission', {
  mounted(el, binding) {
    const requiredPermission = binding.value

    if (!hasPermission(requiredPermission)) {
      // 如果没有权限，隐藏元素
      el.style.display = 'none'
    }
  }
})

// 挂载应用（角色排期由组件在需要时加载）
registerMediaCacheServiceWorker().finally(() => {
  app.mount('#app')
})
